import React, { useState } from 'react';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';

function CustomTextInput({
  value,
  onChangeValue,
  inputType,
  maxValue,
  helperText = '',
  readOnly = false,
  name,
}) {
  const [boxShadow, setBoxShadow] = useState(
    '0px 1px 2px rgba(16, 24, 40, 0.05)'
  );

  const [passwordShow, setPasswordShow] = useState(false);

  return (
    <>
        {inputType === 'password' ? (
          <>
          <div
          onFocus={() => {
            setBoxShadow(
              '0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F4EBFF'
            );
          }}
          onBlur={() => {
            setBoxShadow('0px 1px 2px rgba(16, 24, 40, 0.05)');
          }}
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-around',
            marginRight: '2rem',
            border: "1px solid #D0D5DD",
            padding:1,
            borderWidth: 1,
            borderRadius: 8,
            width:"100%",
          }}
        >
          <div style={{
            display: 'flex',
            flexDirection:"row",
            justifyContent: 'center',
            alignItems: 'center',
          }}>
            <input
              onFocus={() => {
                setBoxShadow(
                  '0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F4EBFF'
                );
              }}
              onBlur={() => {
                setBoxShadow('0px 1px 2px rgba(16, 24, 40, 0.05)');
              }}
              style={{
                backgroundColor: '#FFFFFF',
                borderStyle: 'solid',
                borderColor: '#D0D5DD',
                color: '#667085',
                padding: 10,
                outline: 'none',
                width: '100%',
                // marginTop: '0.5rem',
                flex: 1,
                border:"none",
              }}
              type={passwordShow ? 'text' : 'password'}
              onChange={(e) => {
                onChangeValue(e.target.value);
              }}
              value={value}
              placeholder={name}
              readOnly={readOnly}
            />
            <span>
              <InputAdornment position='end'>
                <IconButton
                  aria-label='toggle password visibility'
                  onClick={() => {
                    setPasswordShow(!passwordShow);
                  }}
                  style={{ cursor: 'pointer' }}
                  edge='end'
                >
                  {passwordShow ? (
                    <VisibilityOffIcon sx={{ fontSize: '25px' , marginRight:"20px"}} />
                  ) : (
                    <VisibilityIcon sx={{ fontSize: '25px' , marginRight:"20px" }} />
                  )}
                </IconButton>
              </InputAdornment>
            </span>
               
          </div>
          </div>
           <p style={{ color: 'red', fontSize: '1.4rem' }}>{helperText}</p>
           </>
        ) :
        inputType === 'Phone'? (
          <>
          <div
          onFocus={() => {
            setBoxShadow(
              '0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F4EBFF'
            );
          }}
          onBlur={() => {
            setBoxShadow('0px 1px 2px rgba(16, 24, 40, 0.05)');
          }}
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-around',
            marginRight: '2rem',
            border: "1px solid #D0D5DD",
            padding:1,
            borderWidth: 1,
            borderRadius: 8,
            width:"100%",
          }}
        >
          <div style={{
            display: 'flex',
            flexDirection:"row",
            justifyContent: 'center',
            alignItems: 'center',
          }}>
            <span>
              <InputAdornment position='start'>
                <div style={{
                  fontSize:"1.4rem",
                  lineHeight:"2.4rem",
                  padding:"0.8rem 0.6rem",
                  borderRight:"1px solid #D0D5DD",
                }} >+91</div>
              </InputAdornment>
            </span>
            <input
              onFocus={() => {
                setBoxShadow(
                  '0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F4EBFF'
                );
              }}
              onBlur={() => {
                setBoxShadow('0px 1px 2px rgba(16, 24, 40, 0.05)');
              }}
              style={{
                backgroundColor: '#FFFFFF',
                borderStyle: 'solid',
                borderColor: '#D0D5DD',
                color: '#667085',
                padding: 9,
                outline: 'none',
                width: '100%',
                flex: 1,
                border:"none",
              }}
              type={inputType}
              onChange={(e) => {
                onChangeValue(e.target.value);
              }}
              value={value}
              placeholder={name}
              readOnly={readOnly}
            />
            
               
          </div>
          </div>
           <p style={{ color: 'red', fontSize: '1.4rem' }}>{helperText}</p>
           </>
        ) : (
          <div 
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-around',
            marginRight: '2rem',
          }}>
            <input
              onFocus={() => {
                setBoxShadow(
                  '0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F4EBFF'
                );
              }}
              onBlur={() => {
                setBoxShadow('0px 1px 2px rgba(16, 24, 40, 0.05)');
              }}
              style={{
                backgroundColor: '#FFFFFF',
                borderStyle: 'solid',
                borderColor: helperText === '' ? '#D0D5DD' : 'red',
                borderWidth: 1,
                borderRadius: 8,
                padding: 10,
                outline: 'none',
                boxShadow: boxShadow,
                width: '100%',
                marginTop: '0.5rem',
                //  max:{maxValue},
                //  maxLength={maxValue},
                flex: 1,
              }}
              readOnly={readOnly}
              value={value}
              onChange={(e) => {
                onChangeValue(e.target.value);
              }}
              type={inputType}
              placeholder={name}
            />
            <p style={{ color: 'red', fontSize: '1.4rem' }}>{helperText}</p>
          </div>
        )}
    </>
  );
}

function CustomReadTextInput({ value, inputType }) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',
        marginRight: '2rem',
      }}
    >
      <input
        style={{
          backgroundColor: '#FFFFFF',
          borderStyle: 'solid',
          borderColor: '#D0D5DD',
          color: '#667085',
          borderWidth: 1,
          borderRadius: 8,
          padding: 10,
          outline: 'none',
          width: '100%',
          marginTop: '0.5rem',
          flex: 1,
        }}
        readOnly={true}
        value={value}
        type={inputType}
      />
    </div>
  );
}

export { CustomTextInput, CustomReadTextInput };
